<template>
  <div class="text-start">
    <v-row no-gutters class="mb-4">
      <v-col>
        <span class="subtitle-1 font-weight-medium primary--text">
          {{ $t(`course.courseDetails.instructions`) }}
        </span>

        <v-divider class="my-2 primary" style="width: 100px" />
      </v-col>
    </v-row>

    <v-row no-gutters class="mb-4">
      <v-col>
        <LocalisedContentEditable
          :values="trainingInstructions"
          @update:values="values => (this.trainingInstructions = values)"
          :text-area-rows="5"
          :placeholder="$t('course.courseDetails.courseInstructionsHere')"
          :editable="isEditing"
          css-class="body-1 font-weight-light textLight--text"
          :selectedLocale="selectedLocale"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LocalisedContentEditable from "@/app/core-module/components/LocalisedContentEditable";

import { createOrUpdateTraining } from "@/app/course-module/methods/createOrUpdateTraining";

export default {
  name: "CourseInstructions",
  components: { LocalisedContentEditable },
  props: {
    training: {
      type: Object,
      required: true,
    },
    isEditing: {
      type: Boolean,
      required: true,
    },
    selectedLocale: {
      type: String,
      default: "en",
    },
  },
  data() {
    return {
      isTrainingSaving: false,
    };
  },
  computed: {
    trainingInstructions: {
      get() {
        return this.training.instructions;
      },
      set(value) {
        this.$emit("update:training", {
          ...this.training,
          instructions: value,
          hasChangesInInstructions: true,
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped />
